import { emptyAccountBalance } from 'common/constants';
import { ICurrencyBalance } from '../features/transfer/transferSlice.types';

export enum CurrencyType {
  'USD' = 'USD',
}

export const formatCurrency = (amount: number, currency: string) => {
  if (amount === null || amount === undefined) {
    return 'N/A';
  }

  if (currency === CurrencyType.USD) {
    return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  } else {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
};

export const calculateBalanceFromHoldings = (
  selectedHoldings: any[] | null,
  isManualFlow: boolean,
  isPartialTransfer: boolean,
  externalAccountBalance: ICurrencyBalance | undefined,
): ICurrencyBalance => {
  if (isManualFlow || !isPartialTransfer || !selectedHoldings) {
    return externalAccountBalance || emptyAccountBalance;
  }

  const currency = selectedHoldings[0]?.price?.currency;

  const totalAmount = selectedHoldings.reduce((sum, holding) => {
    const quantity = holding.quantity ?? 0;
    const priceAmount = holding.price?.amount ?? 0;
    return sum + quantity * priceAmount;
  }, 0);

  const roundedAmount = Math.round(totalAmount * 100) / 100;

  return {
    currency: currency ?? 'USD',
    amount: roundedAmount,
  };
};

export const formatBalanceInput = (formattedValue: string): number => {
  let cleanedValue = formattedValue.replace(/[$,]/g, '');

  const lastPeriodIndex = cleanedValue.lastIndexOf('.');
  cleanedValue = cleanedValue
    .split('')
    .filter((char, index) => char !== '.' || index === lastPeriodIndex)
    .join('');

  const parsedValue = parseFloat(cleanedValue);
  return Math.round(parsedValue * 100) / 100 || 0;
};

export const formatBalanceDisplay = (value: number): string =>
  value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
